export const getStoreKey = (keyName = '', suffix = '') => {
  if (!suffix) return keyName;
  return `${keyName}.${suffix}`;
};
